module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools@2x-c81749664b836d55b64460175fae5d7e.png";